import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { infosMail } from '@core/_utils/tools.utils';
import { actionMail } from "../_const/const";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'infosmail',
  templateUrl: './infosmail.component.html',
  styleUrls: ['./infosmail.component.scss']
})
export class InfosMailComponent implements OnInit {

  @Input() @Output() public infosMailDisplay: infosMail;
  @Input() public bskTypeMail: boolean = false;
  @Input() public editMode: boolean = false;
  @Input() public visuMode: boolean = false;

  @Output() public onSaveMail = new EventEmitter<any>();
  @Output() public mailChange= new EventEmitter<any>()

  public showEditMail: boolean = false;
  public actionMail = [];
  public tempMailInfos: infosMail;
  

  constructor(private translate: TranslateService) { }

  public ngOnInit(): void {
    this.loadActionMail();
    if (this.editMode && this.infosMailDisplay) {
      this.startEditMail();
      this.refreshMailInfo();
    }
  }
  
  public startEditMail() {
    this.showEditMail = true;
    this.tempMailInfos = JSON.parse(JSON.stringify(this.infosMailDisplay));
    this.tempMailInfos.dateLimit = this.infosMailDisplay.dateLimit;
  }
  
  public clickSaveMail(event) {
    this.refreshMailInfo();
    this.onSaveMail.emit(this.infosMailDisplay);
    this.showEditMail = false;
  }
  
  public mailInfoChange() {
    this.infosMailDisplay.mailLimit = true;
  }
  
  public clickCancelMail() {
    this.showEditMail = false;
    this.infosMailDisplay = this.tempMailInfos;
  }
  
  public refreshMailInfo() {
    // let searchlabel = this.searchInJson(this.actionMail, this.infosMailDisplay.mailAction);
    this.infosMailDisplay.mailActionLabel = this.translate.instant('Mail_' + this.infosMailDisplay.mailAction);
  }
  
  private searchInJson (data, value){
    return data.filter(
        function(data){ return data.value == value }
    );
  }

  private loadActionMail() {
    this.actionMail = [];
    actionMail.map(item => {
      this.actionMail.push({ label: this.translate.instant('Mail_'+item.value), value: item.value});
    });
  }
}
